import { Button } from '@nextui-org/react'
import { useFormCampaignContext } from '../hooks/useFormCampaignContext'
import { webApiService } from '@/services'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { IAppStore } from '@/models/store.model'
import moment from 'moment'
import { enqueueSnackbar } from 'notistack'
import { PrivateRoutes } from '@/constants/routes'

const StepButtons = () => {
  const { id, slug } = useParams()
  const userState = useSelector((store: IAppStore) => store.user)
  const { ctx, saveCtx } = useFormCampaignContext()
  const navigate = useNavigate()

  const checkDisable: () => boolean = () => {
    if (ctx.step === 0) {
      if (ctx.form.name === '' || ctx.form.scope === '' || (ctx.form.scope !== 'BUY' && ctx.form.sbuId === '') || (ctx.form.scope === 'BRAND' && ctx.form.brandId === '') || (ctx.form.scope === 'MODEL' && (ctx.form.brandId === '' || ctx.form.modelId === '')) || (ctx.form.scope === 'BUY' && ctx.form.buy === '')) {
        return true
      }
    }

    if (ctx.step === 1) {
      if (ctx.form.amount === '' || ctx.form.amount === '0') {
        return true
      }
    }

    return false
  }

  const nextStep = () => {
    if (ctx.step < 1) {
      saveCtx({ ...ctx, step: ctx.step + 1 })
    } else {
      // Aquí puedes manejar el envío del formulario si es el último paso
      console.log('Formulario final:', ctx.form)

      saveCtx({ ...ctx, loading: true })
      // Aquí llamas a tu API para guardar en la base de datos
      const startDate = moment({ year: ctx.form.startDate.year, month: ctx.form.startDate.month - 1, day: ctx.form.startDate.day }).format('YYYY-MM-DD')
      const endDate = moment({ year: ctx.form.endDate.year, month: ctx.form.endDate.month - 1, day: ctx.form.endDate.day }).format('YYYY-MM-DD')
      webApiService.saveContribution({ ...ctx.form, seller: String(slug), createdBy: userState.id, id: String(id) === 'new' ? 0 : id, startDate, endDate })
        .then((res) => {
          console.log('Campaña creada:', res.data)
          enqueueSnackbar(ctx.form.id === 0 ? 'Campaña creada con éxito.' : 'Campaña actualizada con éxito.', { variant: 'success' })
          navigate(PrivateRoutes.CONTRIBUTIONS.replace(':slug', String(slug)))
        })
        .catch((err) => {
          console.error('Error al crear la campaña:', err)
          enqueueSnackbar('Error al crear campaña', { variant: 'error' })
        })
        .finally(() => {
          saveCtx({ ...ctx, loading: false })
        })
    }
  }

  return (
    <div className='grid grid-cols-2 gap-4 max-w-3xl mx-auto'>
      <div>
        {ctx.step > 0 && (
          <Button
            variant='bordered'
            color='primary'
            onPress={() => {
              saveCtx({ ...ctx, step: ctx.step - 1 })
            }}
          >Anterior
          </Button>
        )}
      </div>
      <div className='flex'>
        <Button
          variant='solid'
          color='primary'
          className='ms-auto'
          isDisabled={checkDisable()}
          isLoading={ctx.loading}
          onPress={nextStep}
        >{ctx.step < 1 ? 'Siguiente' : 'Guardar'}
        </Button>
      </div>
    </div>
  )
}

export default StepButtons
